import React, { useEffect, useRef, useState } from "react";
import { Transition } from "react-transition-group";

import CtmPhone from "./CtmPhone";
import Input from "./Input";
import Modal from "./Modal";

const iconTp = new URL("../assets/images/tp-dark.svg", import.meta.url);
const iconDove = new URL("../assets/images/icon-dove.svg", import.meta.url);
const iconArrow = new URL("../assets/images/arrow.svg", import.meta.url);
const iconP1 = new URL("../assets/images/icon-p1.svg", import.meta.url);
const iconP2 = new URL("../assets/images/icon-p2.svg", import.meta.url);

const defaultStepTitle = "Hur kan vi hjälpa dig?";
const defaultNextTitle = "Nästa";

export default function BookingForm({ closeForm }) {
  const [type, setType] = useState(1);
  const [step, setStep] = useState(1);
  const [stepsStatus, setStepsStatus] = useState([true, false, false]);
  const [stepTitle, setStepTitle] = useState(defaultStepTitle);
  const [nextButtonText, setNextButtonText] = useState(defaultNextTitle);
  const [errors, setErrors] = useState({});
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [submittedStep, setSubmittedStep] = useState(false);

  useEffect(() => {
    switch (step) {
      case 3:
        setStepTitle(
          "Vi ringer upp dig inom en arbetsdag. På vilket nummer når vi dig enklast?"
        );
        setNextButtonText("Boka rådgivning");
        break;
      case 2:
        if (type === 1) {
          setStepTitle("Vi beklagar sorgen.<br />Vad heter du?");
        } else {
          setStepTitle("Då har du kommit rätt.<br />Vad heter du?");
        }
        setNextButtonText(defaultNextTitle);
        break;
      default:
      case 1:
        setStepTitle(defaultStepTitle);
        setNextButtonText(defaultNextTitle);
        break;
    }
  }, [step]);

  useEffect(() => {
    if (step !== 2) {
      return;
    }

    let status = false;
    if (errors["firstname"] === false && errors["lastname"] === false) {
      status = true;
    }

    setStepsStatus((state) => {
      const st = [...state];
      st[step - 1] = status;
      return st;
    });
  }, [firstName, lastName]);

  useEffect(() => {
    if (step !== 3) {
      return;
    }

    let status = false;
    if (errors["phone"] === false) {
      status = true;
    }

    setStepsStatus((state) => {
      const st = [...state];
      st[step - 1] = status;
      return st;
    });
  }, [phone]);

  const toBackStage = () => {
    setStep((st) => st - 1);
  };

  const toNextStage = () => {
    const nextStep = step + 1;
    if (nextStep <= 3) {
      setStep((st) => st + 1);
      return;
    }

    submitForm();
  };

  const submitForm = () => {
    const formData = new FormData();
    // formData.append("bookmeetingcity", cookies.get("fenix4city"));
    formData.append("bookmeetingcity", "");
    formData.append("namn", firstName);
    formData.append("fornamn", lastName);
    formData.append("telefon", phone);
    formData.append("sourcetype", "3");
    formData.append("type", "1");
    formData.append("serviceType", type === 1 ? "Begravning" : "Juridik");
    const requestOptions = {
      method: "POST",
      body: formData,
    };
    fetch(
      process.env.AJAX_URL + "/wp-content/themes/fenix4/pages/ajax-submit.php",
      requestOptions
    )
      .then((response) => response)
      .finally(() => {
        setSubmittedStep(true);
      });

    fetch(
      process.env.AJAX_URL +
        "/wp-content/themes/fenix4/mailer/mailtokund_book.php",
      requestOptions
    ).finally(() => {});
  };

  const textValidate = (name, value) => {
    const letters = /^[a-zA-Z][a-zA-Z '`´-]*$/;
    let isValid = true;
    let msg = "";
    if (value.length < 2) {
      isValid = false;
      msg = "Du måste ange minst 2 tecken.";
    }
    // if (!letters.test(String(value))) {
    //   isValid = false;
    //   msg = "Vänligen endast bokstäver.";
    // }

    setErrors((state) => {
      const errs = { ...state };
      errs[name] = isValid ? false : msg;
      return errs;
    });

    return isValid;
  };

  const phoneValidate = (value) => {
    const ph = /^([0|+[0-9]{1,9})?([\w.-])?([1-9][0-9]{3,9})$/;
    let isValid = false;
    if (ph.test(String(value))) {
      isValid = true;
    }

    setErrors((state) => {
      const errs = { ...state };
      errs["phone"] = isValid
        ? false
        : "Fel format på telefonnummer (prova 0XXXXXXXXXX eller +4XXXXXXXXXX).";
      return errs;
    });

    return isValid;
  };

  return (
    <Modal
      title="Menu"
      titleClass="font-pprightgothic text-4xl text-white text-center"
      onClose={() => closeForm()}
    >
      <div className="w-full mx-auto h-full max-w-[400px]">
        <div className="flex flex-col items-center min-h-[350px] justify-between">
          {submittedStep ? (
            <>
              <div className="text-center">
                <img className="mx-auto my-5" src={iconDove} width={80} />
                <h1 className="text-[28px] text-dark-blue font-pprightgothic leading-[1.1] mb-3">
                  Tack
                </h1>
                <div>
                  Vi hör av oss till dig på så snart vi kan (inom en arbetsdag).
                  Har du frågor eller funderingar innan dess får du gärna ringa{" "}
                  <CtmPhone />
                </div>
              </div>

              <button
                className="font-interbold rounded-full bg-yellow text-dark-blue uppercase text-[14px] py-3 px-4 border-yellow text-dark-blue"
                onClick={() => closeForm()}
              >
                stäng
              </button>
            </>
          ) : (
            <>
              <div className="text-center mb-5">
                <img className="mb-3 mx-auto" src={iconTp} width={200} />
                <h1 className="text-[28px] text-dark-blue font-pprightgothic leading-[1.1]">
                  <span dangerouslySetInnerHTML={{ __html: stepTitle }} />
                </h1>
              </div>
              {step === 1 && (
                <div className="flex flex-col items-center">
                  <div>
                    <div
                      className={`flex gap-2 items-center cursor-pointer rounded-full py-3 px-4 ${
                        type === 1 ? "bg-dark-blue text-white" : ""
                      }`}
                      onClick={() => setType(1)}
                    >
                      <img src={iconP1} width={26} />
                      <div>Jag har förlorat en anhörig</div>
                    </div>
                    <div
                      className={`flex gap-2 items-center cursor-pointer rounded-full py-3 px-4 ${
                        type === 2 ? "bg-dark-blue text-white" : ""
                      }`}
                      onClick={() => setType(2)}
                    >
                      <img src={iconP2} width={26} />
                      <div>Jag behöver juridisk rådgivning</div>
                    </div>
                  </div>
                </div>
              )}
              {step === 2 && (
                <div className="w-full mb-8">
                  <div className="mb-4">
                    <Input
                      type="text"
                      label="Förnamn"
                      required={true}
                      name="firstname"
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                        textValidate("firstname", e.target.value);
                      }}
                      error={errors["firstname"] ?? false}
                    />
                  </div>
                  <div className="">
                    <Input
                      type="text"
                      label="Efternamn"
                      required={true}
                      name="lastname"
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                        textValidate("lastname", e.target.value);
                      }}
                      error={errors["lastname"] ?? false}
                    />
                  </div>
                </div>
              )}
              {step === 3 && (
                <div className="w-full mb-8">
                  <div className="mb-4">
                    <Input
                      type="text"
                      label="Telefonnummer"
                      required={true}
                      name="phone"
                      value={phone}
                      onChange={(e) => {
                        setPhone(e.target.value);
                        phoneValidate(e.target.value);
                      }}
                      error={errors["phone"] ?? false}
                    />
                  </div>
                </div>
              )}
              <div
                className={`flex w-full items-center ${
                  step === 1 ? "justify-center" : "justify-between"
                }`}
              >
                {step > 1 && (
                  <button
                    className="font-intermedium rounded-full bg-dark-blue text-dark-blue uppercase text-[14px] py-2 px-4 border-2 bg-white border-dark-blue"
                    onClick={toBackStage}
                  >
                    Tillbaka
                  </button>
                )}
                <button
                  className="font-interbold flex items-center rounded-full bg-dark-blue text-white uppercase text-[14px] py-3 px-4 self-center outline-0 disabled:opacity-40"
                  onClick={toNextStage}
                  disabled={stepsStatus[step - 1] === false}
                >
                  {nextButtonText}
                  {step !== 3 && (
                    <img src={iconArrow} className="ml-2 h-[16px]" />
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}
